// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"177":"home","963":"privacy-policy"}[chunkId] + "." + {"177":"fe905384","963":"e9d18af1"}[chunkId] + ".js";
};